export type ClassValue = string | number | false | null | undefined;

/** Minimal className joiner. Keeps the UI package dependency-free. */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
